'use client';

import { ReactNode } from 'react';

import { CaseStudyAside, type CaseStudyAsideProps } from './case-study-aside';

interface CaseStudyBodyProps {
  /** Article markdown / prose JSX */
  children: ReactNode;
  aside: CaseStudyAsideProps;
}

export const CaseStudyBody = ({ children, aside }: CaseStudyBodyProps) => (
  <section className="bg-white py-20 md:py-28">
    <div className="container">
      <div className="flex flex-col gap-12 lg:flex-row lg:gap-20">
        <article
          className="prose prose-neutral prose-lg mx-auto max-w-3xl
          prose-headings:font-sans
          prose-headings: prose-headings:text-neutral-900
          prose-h2:text-2xl prose-h2:leading-tight prose-h2:md:text-3xl
          prose-h3:text-xl prose-h3:md:text-2xl
          prose-p:text-neutral-700
          prose-a:text-neutral-900 prose-a:underline-offset-4"
        >
          {children}
        </article>

        <CaseStudyAside {...aside} />
      </div>
    </div>
  </section>
);

interface CaseStudyResultsTableProps {
  metricLabel: ReactNode;
  impactLabel: ReactNode;
  rows: { metric: ReactNode; impact: ReactNode }[];
}

export const CaseStudyResultsTable = ({
  metricLabel,
  impactLabel,
  rows,
}: CaseStudyResultsTableProps) => (
  <table className="not-prose w-full overflow-hidden rounded-2xl border border-neutral-200 text-sm">
    <thead className="bg-neutral-50">
      <tr className="ltr:text-left rtl:text-right">
        <th className="px-5 py-3 font-medium text-neutral-700">{metricLabel}</th>
        <th className="px-5 py-3 font-medium text-neutral-700">{impactLabel}</th>
      </tr>
    </thead>
    <tbody className="divide-y divide-neutral-200">
      {rows.map((row, i) => (
        <tr key={i}>
          <td className="px-5 py-3 text-neutral-700">{row.metric}</td>
          <td className="px-5 py-3 font-medium text-neutral-900">
            {row.impact}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default CaseStudyBody;
